module.exports = __webpack_public_path__ + "img/2020_S.b7e9847f.png";